// extracted by mini-css-extract-plugin
module.exports = {"button":"ToggleButton_button__dUMjc","content":"ToggleButton_content__Ct0bP","contentActive":"ToggleButton_contentActive__VpuaS"};